import gtm from '@/utils/gtm';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import './index.scss';

export interface EfTabItemProps<T = string> {
    /**
     * 点击后切换到哪个 type
     */
    type: T;
    /**
     * 标题文案
     */
    title: string;
}

export interface EfTabProps {
    /**
     * 类型
     */
    type?: 'round';
    /**
     * 主题色
     */
    theme?: 'white' | 'black';
    /**
     * 主题色
     */
    activeType?: string;
    /**
     * 列表
     */
    items: EfTabItemProps[];
    /**
     * 样式名
     */
    className?: string;
    /**
     * list_name (gtm)
     */
    list_name?: string;
    /**
     * 切换回调
     */
    onChange?: (item: EfTabItemProps, index: number) => void;
}

/**
 * 维护:谢保林
 *
 * 左右切换 tab
 */
const EfTab: React.FC<EfTabProps> = ({ theme, type, activeType, list_name, items = [], className, onChange }) => {
    const prefixCls = `ef-tab`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-${theme}`]: theme,
        [`${prefixCls}-type-${type}`]: type,
    });
    const firstItem = items[0] || {};
    const [activeType2, setActiveType2] = useState(activeType || firstItem.type || '');
    // 点击切换
    const toggleHandle = (item: EfTabItemProps, index: number) => {
        setActiveType2(item.type);
        onChange && onChange(item, index);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: list_name || 'none',
            button_name: item.title,
            __btn_id1: prefixCls,
            __btn_id2: item.title,
        });
    };

    useEffect(() => {
        if (activeType) {
            setActiveType2(activeType);
        }
    }, [activeType]);

    useEffect(() => {
        if (items?.length > 0 && !activeType && items[0]?.type) {
            setActiveType2(items[0]?.type);
        }
    }, [items]);

    return (
        <div className={classes}>
            {items?.map((item: EfTabItemProps, index: number) => {
                return (
                    <div
                        className={`${prefixCls}-item${activeType2 === item.type ? ` ${prefixCls}-item-active` : ''} GtmModuleData-btn-text`}
                        key={index}
                        onClick={() => {
                            toggleHandle(item, index);
                        }}
                    >
                        {item.title}
                    </div>
                );
            })}
        </div>
    );
};

export default EfTab;
